import { render } from "./RakutenHomeHotCloth.vue?vue&type=template&id=0b21b87e"
import script from "./RakutenHomeHotCloth.vue?vue&type=script&lang=js"
export * from "./RakutenHomeHotCloth.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__